<template>
  <div id="app">
    <Header
      v-if="
        $route.meta.layout === 'dashboard' || $route.meta.layout === 'login'
      "
      :userData="userData"
    />
    <div id="content">
      <div></div>
      <div class="router-view">
        <router-view></router-view>
      </div>
      <div></div>
      <!-- Sidebar -->
      <Sidebar :userData="userData" @action:logout="logout" />
    </div>

    <Footer
      v-if="
        $route.meta.layout === 'dashboard' || $route.meta.layout === 'login'
      "
    />
  </div>
</template>

<script>
import { api } from "@/api";

import Header from "./components/layouts/Header.vue";
import Sidebar from "./components/layouts/Sidebar/index";
import Footer from "./components/layouts/Footer.vue";
import Swal from "sweetalert2";

import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Header,
    Sidebar,
    Footer,
  },
  computed: {
    ...mapGetters({
      userData: "general/getUserData",
    }),
  },
  watch: {
    $route: {
      handler(val) {
        const isUserDataExists = Object.keys(this.userData).length;
        if (val.name !== "login" && !isUserDataExists)
          this.setUserData(this.userData);

        if (val.meta.layout === "dashboard") {
          this.getUser();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // remove cookie token when session ends
    if (this.$route.meta.layout === "dashboard") {
      if (!sessionStorage.getItem("token")) {
        this.handleEndSessionSuccess();
      }
    }
  },
  methods: {
    ...mapActions({
      setUserData: "general/setUserData",
    }),
    async getUser() {
      try {
        const response = await api.profile.get();
        this.userData = response.data;
        this.setUserData(response.data);
      } catch (error) {
        console.error(error);
      }
    },
    goTo(path) {
      if (this.$route.path !== path && path.includes("profile")) {
        this.$router.push(`${path}/${this.userData.id}`);
      } else this.$router.push(path);
    },
    logout() {
      Swal.fire({
        title: "Confirm",
        text: "Are you sure you want to logout ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, log me out",
        cancelButtonColor: "red",
        customClass: {
          confirmButton: "confirmButton",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.endSession();
        }
      });
    },
    async endSession() {
      const payload = {
        refreshToken: cookies.get("refreshToken"),
      };

      try {
        await api.auth.logout(payload);
        this.handleEndSessionSuccess();
      } catch (error) {
        console.error(error);
      }
    },
    handleEndSessionSuccess() {
      cookies.remove("token");
      cookies.remove("refreshToken");
      this.$router.push("/web/login");
    },
  },
};
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#content {
  flex: 1;
}
</style>
